import { UseQueryResult, useQuery } from "react-query";

import { SessionType } from "../../../../../../lib/types";
import { useAxios } from "../../hooks/useAxios";

export interface IFetchWorkspaceSessionCountParams {
  days_ago: number;
  session_type: SessionType;
  include_previous_period?: boolean;
  include_top_workspace_check?: boolean;
}

export interface IFetchWorkspaceSessionCountResponse {
  session_count: string;
  previous_period_session_count: string;
  top_half_of_all_workspaces: boolean;
  top_third_of_all_workspaces: boolean;
}

export default function useFetchWorkspaceSessionCount({
  session_type,
  days_ago,
  include_previous_period = false,
  include_top_workspace_check = false,
}: IFetchWorkspaceSessionCountParams): UseQueryResult<
  IFetchWorkspaceSessionCountResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<IFetchWorkspaceSessionCountResponse>(
    [
      "workspace-session-count",
      {
        days_ago,
        session_type,
        include_previous_period,
        include_top_workspace_check,
      },
    ],
    async (): Promise<IFetchWorkspaceSessionCountResponse> => {
      return await axios
        .get(`/v1/practice-sets/sessions/workspace/count`, {
          params: {
            session_type,
            days_ago,
            include_previous_period,
            include_top_workspace_check,
          },
        })
        .then((r) => {
          return r.data as IFetchWorkspaceSessionCountResponse;
        });
    }
  );

  return query;
}
